import { Ecdn10Data } from '../ecdn10/interfaces';
import get10AgentInfo, { EMPTY_10_DATA } from '../ecdn10/get10AgentInfo';
import logger from '../log';
import racedPromise from '../common/utils/racedPromise';
import { addDuration } from '../common/utils/duration';
import { BasePromiseData } from './interfaces';

const log = logger.getLogger(__filename);

const get10Data = (obj: BasePromiseData): Promise<Ecdn10Data> => {
  const { base, config, vals } = obj;
  if (config.legacy.disabled) {
    return Promise.resolve(EMPTY_10_DATA);
  }
  return racedPromise({
    ...base,
    callback: value => {
      log.debug('10 Agent Data finished', value);
      addDuration({ vals, key: '10' });
    },
    exceptionCallback: e => {
      const err = e as Record<string, unknown>;
      log.warn('Unable to gather 10 information', err);
    },
    promise: get10AgentInfo(),
    response: EMPTY_10_DATA
  });
};

export default get10Data;
